import * as React from 'react';
import { DATA_HOOKS } from './constants';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { Modal } from '../internal/Modal';
import { IconButton } from '../IconButton';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { st, classes } from './Dialog.st.css';
import { DialogProps, DialogDefaultProps } from './types';

/** Dialog */
export class Dialog extends React.Component<DialogProps> {
  static displayName = 'Dialog';
  static defaultProps: DialogDefaultProps = {
    isOpen: false,
    manualFocus: false,
    notFullscreenOnMobile: false,
  };

  render() {
    const {
      className,
      isOpen,
      manualFocus,
      closeButtonRef,
      onClose,
      children,
      contentClassName,
      childrenWrapperClassName,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      'aria-describedby': ariaDescribedBy,
      closeButtonAriaLabel,
      closeButtonAriaLabelledby,
      wiredToSiteColors,
      notFullscreenOnMobile,
      appendToBody,
      forceBWTheme,
    } = this.props;

    return (
      <TPAComponentsConsumer>
        {({ mobile, rtl }) => {
          const wrapperClassName = st(
            classes.root,
            {
              mobile,
              rtl,
              wired: wiredToSiteColors,
              notFullscreenMobile: mobile && notFullscreenOnMobile,
            },
            classes[`skin-${wiredToSiteColors ? 'wired' : 'fixed'}`],
            className,
          );

          return (
            <div
              className={appendToBody ? undefined : wrapperClassName}
              data-hook={this.props['data-hook']}
              data-mobile={mobile}
            >
              <Modal
                isOpen={isOpen}
                focusTrap={!manualFocus}
                onRequestClose={onClose}
                forceBWTheme={forceBWTheme && !wiredToSiteColors}
                appendToBody={appendToBody}
                className={appendToBody ? wrapperClassName : undefined}
              >
                <div
                  className={st(classes.outerContentWrapper, { appendToBody })}
                >
                  <div
                    className={`${classes.contentWrapper} ${
                      contentClassName || ''
                    }`}
                    role="dialog"
                    aria-modal="true"
                    aria-label={ariaLabel}
                    aria-labelledby={ariaLabelledBy}
                    aria-describedby={ariaDescribedBy}
                  >
                    <div className={classes.closeButtonWrapper}>
                      <IconButton
                        className={classes.closeIconButton}
                        data-hook={DATA_HOOKS.CLOSE_BTN}
                        aria-label={closeButtonAriaLabel}
                        aria-labelledby={closeButtonAriaLabelledby}
                        innerRef={closeButtonRef}
                        onClick={onClose}
                        icon={<Close />}
                      />
                    </div>
                    <div
                      className={`${classes.dialogContent} ${
                        childrenWrapperClassName || ''
                      }`}
                    >
                      {children}
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          );
        }}
      </TPAComponentsConsumer>
    );
  }
}
